const testData: any = [
    {id: '1', code: '51024685956', name: '濑溪河大闸水文站', area: '濑溪河大闸水文站', unit: '福集镇', type: '濑溪河1', elevation: '河道水位站', riverArea: '300', year: '2020', updateDate: '2020-5-6', szArea: '2000', qx: '区县1'},
    {id: '2', code: '51024685957', name: '泸县水务局', area: '泸县水务局', unit: '泸县', type: '濑溪河2', elevation: '水库水位站', year: '2020', riverArea: '300',updateDate: '2020-5-5', szArea: '2030', qx: '区县23'},
    {id: '3', code: '51024685958', name: '艾大桥水库管理站', area: '濑溪河测站2', unit: '福集镇', type: '濑溪河3', elevation: '水库水位站', riverArea: '300',year: '2020', updateDate: '2020-5-4', szArea: '20200', qx: '区县3'},
    {id: '4', code: '51024685959', name: '泸县水务局', area: '艾大桥水库堰闸站', unit: '福集镇', type: '濑溪河4', elevation: '水库水位站',riverArea: '300', year: '2020', updateDate: '2020-3-5', szArea: '2100', qx: '区县4'},
    {id: '5', code: '51024685960', name: '濑溪河大闸水文站', area: '九曲河中测站', unit: '泸县', type: '濑溪河5', elevation: '河道水位站', riverArea: '300',year: '2020', updateDate: '2020-5-15', szArea: '500', qx: '区县1'},
    {id: '6', code: '51024685960', name: '泸县水务局', area: '濑溪河大闸水文站', unit: '泸县', type: '濑溪河2', elevation: '水库水位站', riverArea: '300',year: '2020', updateDate: '2020-3-5', szArea: '8584', qx: '区县5'},
    {id: '7', code: '51024685962', name: '濑溪河大闸水文站', area: '渠首测站', unit: '福集镇', type: '濑溪河2', elevation: '河道水位站', riverArea: '300',year: '2020', updateDate: '2020-4-12', szArea: '123.32', qx: '区县2'},
    {id: '8', code: '51024685963', name: '泸县水务局', area: '渠首测站', unit: '福集镇', type: '濑溪河3', elevation: '水库水位站', riverArea: '300',year: '2020', updateDate: '2020-8-3', szArea: '4323.3', qx: '区县123'},
    {id: '9', code: '51024685964', name: '艾大桥水库管理站', area: '渠首测站', unit: '泸县', type: '濑溪河4', elevation: '水库水位站', riverArea: '300',year: '2020', updateDate: '2020-3-4', szArea: '4002', qx: '区县7'},
    {id: '10', code: '51024685965', name: '濑溪河大闸水文站', area: '渠首测站', unit: '泸县', type: '濑溪河5', elevation: '水库水位站', riverArea: '300',year: '2020', updateDate: '2020-12-1', szArea: '25423', qx: '区县9'},
    {id: '11', code: '51024685966', name: '艾大桥水库管理站', area: '渠首测站', unit: '福集镇', type: '濑溪河2', elevation: '河道水位站', riverArea: '300',year: '2020', updateDate: '2020-7-26', szArea: '1233', qx: '区县34'},
    {id: '12', code: '51024685967', name: '艾大桥水库管理站', area: '渠首测站', unit: '泸县', type: '濑溪河1', elevation: '水库水位站', riverArea: '300',year: '2020', updateDate: '2020-8-5', szArea: '343', qx: '区县56'},
    {id: '1', code: '51024685956', name: '濑溪河大闸水文站', area: '渠首测站', unit: '福集镇', type: '濑溪河1', elevation: '河道水位站', riverArea: '300',year: '2020', updateDate: '2020-5-6', szArea: '2000', qx: '区县1'},
    {id: '2', code: '51024685957', name: '泸县水务局', area: '渠首测站', unit: '泸县', type: '濑溪河2', elevation: '水库水位站',riverArea: '300', year: '2020', updateDate: '2020-5-5', szArea: '2030', qx: '区县23'},
    {id: '3', code: '51024685958', name: '艾大桥水库管理站', area: '渠首测站', unit: '福集镇', type: '濑溪河3', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-5-4', szArea: '20200', qx: '区县3'},
    {id: '4', code: '51024685959', name: '泸县水务局', area: '渠首测站', unit: '福集镇', type: '濑溪河4', elevation: '水库水位站', riverArea: '300',year: '2020', updateDate: '2020-3-5', szArea: '2100', qx: '区县4'},
    {id: '5', code: '51024685960', name: '濑溪河大闸水文站', area: '渠首测站', unit: '泸县', type: '濑溪河5', elevation: '河道水位站', riverArea: '300', year: '2020', updateDate: '2020-5-15', szArea: '500', qx: '区县1'},
    {id: '6', code: '51024685960', name: '泸县水务局', area: '渠首测站', unit: '泸县', type: '濑溪河2', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-3-5', szArea: '8584', qx: '区县5'},
    {id: '7', code: '51024685962', name: '濑溪河大闸水文站', area: '渠首测站', unit: '福集镇', type: '濑溪河2', elevation: '河道水位站', riverArea: '300', year: '2020', updateDate: '2020-4-12', szArea: '123.32', qx: '区县2'},
    {id: '8', code: '51024685963', name: '泸县水务局', area: '渠首测站', unit: '福集镇', type: '濑溪河3', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-8-3', szArea: '4323.3', qx: '区县123'},
    {id: '9', code: '51024685964', name: '艾大桥水库管理站', area: '九曲河中测站', unit: '泸县', type: '濑溪河4', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-3-4', szArea: '4002', qx: '区县7'},
    {id: '10', code: '51024685965', name: '濑溪河大闸水文站', area: '九曲河中测站', unit: '泸县', type: '濑溪河5', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-12-1', szArea: '25423', qx: '区县9'},
    {id: '11', code: '51024685966', name: '艾大桥水库管理站', area: '九曲河中测站', unit: '福集镇', type: '濑溪河2', elevation: '河道水位站', riverArea: '300', year: '2020', updateDate: '2020-7-26', szArea: '1233', qx: '区县34'},
    {id: '12', code: '51024685967', name: '艾大桥水库管理站', area: '九曲河中测站', unit: '泸县', type: '濑溪河1', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-8-5', szArea: '343', qx: '区县56'},
    {id: '1', code: '51024685956', name: '濑溪河大闸水文站', area: '九曲河中测站', unit: '福集镇', type: '濑溪河1', elevation: '河道水位站', riverArea: '300', year: '2020', updateDate: '2020-5-6', szArea: '2000', qx: '区县1'},
    {id: '2', code: '51024685957', name: '泸县水务局', area: '艾大桥水库堰闸站', unit: '泸县', type: '濑溪河2', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-5-5', szArea: '2030', qx: '区县23'},
    {id: '3', code: '51024685958', name: '艾大桥水库管理站', area: '艾大桥水库堰闸站', unit: '福集镇', type: '濑溪河3', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-5-4', szArea: '20200', qx: '区县3'},
    {id: '4', code: '51024685959', name: '泸县水务局', area: '艾大桥水库堰闸站', unit: '福集镇', type: '濑溪河4', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-3-5', szArea: '2100', qx: '区县4'},
    {id: '5', code: '51024685960', name: '濑溪河大闸水文站', area: '艾大桥水库堰闸站', unit: '泸县', type: '濑溪河5', elevation: '河道水位站', riverArea: '300', year: '2020', updateDate: '2020-5-15', szArea: '500', qx: '区县1'},
    {id: '6', code: '51024685960', name: '泸县水务局', area: '濑溪河大闸水文站', unit: '泸县', type: '濑溪河2', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-3-5', szArea: '8584', qx: '区县5'},
    {id: '7', code: '51024685962', name: '濑溪河大闸水文站', area: '濑溪河大闸水文站', unit: '福集镇', type: '濑溪河2', elevation: '河道水位站', riverArea: '300', year: '2020', updateDate: '2020-4-12', szArea: '123.32', qx: '区县2'},
    {id: '8', code: '51024685963', name: '泸县水务局', area: '濑溪河大闸水文站', unit: '福集镇', type: '濑溪河3', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-8-3', szArea: '4323.3', qx: '区县123'},
    {id: '9', code: '51024685964', name: '艾大桥水库管理站', area: '濑溪河大闸水文站', unit: '泸县', type: '濑溪河4', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-3-4', szArea: '4002', qx: '区县7'},
    {id: '10', code: '51024685965', name: '濑溪河大闸水文站', area: '濑溪河大闸水文站', unit: '泸县', type: '濑溪河5', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-12-1', szArea: '25423', qx: '区县9'},
    {id: '11', code: '51024685966', name: '艾大桥水库管理站', area: '濑溪河大闸水文站', unit: '福集镇', type: '濑溪河2', elevation: '河道水位站', riverArea: '300', year: '2020', updateDate: '2020-7-26', szArea: '1233', qx: '区县34'},
    {id: '12', code: '51024685967', name: '艾大桥水库管理站', area: '濑溪河大闸水文站', unit: '泸县', type: '濑溪河1', elevation: '水库水位站', riverArea: '300', year: '2020', updateDate: '2020-8-5', szArea: '343', qx: '区县56'}
  ];
const columns: any = [
  {
    name: 'code',
    header: '取用水户代码',
    attrs: {
      width: '100',
      type: 'float'
    },
  },
  {
    name: 'meterNumber',
    header: '水表编号',
    attrs: {
      width: '100',
      type: 'float'
    },
  },
  {
    name: 'name',
    header: '取用水户名称',
    attrs: {
      width: '100',
    },
  },
  {
    name: 'areaCode',
    header: '区域',
    attrs: {
      width: '100',
    },
  },
  {
    name: 'channelName',
    header: '渠',
    attrs: {
      width: '100',
    },
  },
  {
    name: 'date',
    header: '取水日期',
    attrs: {
      width: '100',
    },
    others: {
      type: 'date',
    }
  },
  {
    name: 'areatype',
    header: '类型',
    attrs: {
      width: '100',
    },
    others: {
      type: 'select',
      name: 'text',
      value: 'value',
      // url: this.urlService.common.liuyu,
      placeHolder: '请选择类型'
    }
  },
];
// 测试数据 表头数据
const mapperList: any = [
  {
    propertyName: 'num',
    showFormatter: {
      showName: '客户编号',
      description: '编号',
    }
  },
  {
    propertyName: 'name',
    showFormatter: {
      showName: '客户姓名',
      description: '姓名',
    }
  },
  {
    propertyName: 'age',
    showFormatter: {
      showName: '年龄',
      description: '年龄',
    }
  },
  {
    propertyName: 'sex',
    showFormatter: {
      showName: '客户性别',
      description: '性别',
    }
  },
  {
    propertyName: 'address',
    showFormatter: {
      showName: '客户住址',
      description: '住址',
      collapse: 'true'
    }
  },
  {
    propertyName: 'phone',
    showFormatter: {
      showName: '客户电话',
      description: '电话',
      // collapse: 'false'
    }
  },
  {
    propertyName: 'company',
    showFormatter: {
      showName: '客户公司',
      description: '公司',
    }
  },
  {
    propertyName: 'ctype',
    showFormatter: {
      showName: '客户类别',
      description: '类别',
    }
  },
  {
    propertyName: 'totalPerson',
    showFormatter: {
      showName: '公司总人数',
      description: '总人数',
    }
  },
];
export {testData, columns, mapperList};
